import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-rose-900 text-white" data-id="element-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-8" data-id="element-29">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-30">
          <div data-id="element-31">
            <Logo className="text-white mb-4" data-id="element-32" />
            <p className="text-rose-100 mt-4" data-id="element-33">
              We specialise in fast, professional appliance repairs and service
              plans across the UK. Our trusted engineers are here to help with
              fixed-price support and UK-based service.
            </p>
          </div>
          <div data-id="element-34">
            <h3 className="text-lg font-semibold mb-4" data-id="element-35">Quick Links</h3>
            <ul className="space-y-2" data-id="element-36">
              <li data-id="element-37">
                <Link to="/" className="text-rose-100 hover:text-white" data-id="element-38">
                  Home
                </Link>
              </li>
              <li data-id="element-39">
                <Link to="/service-coverage" className="text-rose-100 hover:text-white" data-id="element-40">
                  Service Coverage
                </Link>
              </li>
              <li data-id="element-41">
                <Link to="/about" className="text-rose-100 hover:text-white" data-id="element-42">
                  About Us
                </Link>
              </li>
              <li data-id="element-43">
                <Link to="/contact" className="text-rose-100 hover:text-white" data-id="element-44">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-45">
                <Link to="/faq" className="text-rose-100 hover:text-white" data-id="element-46">
                  FAQs
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-47">
            <h3 className="text-lg font-semibold mb-4" data-id="element-48">Policies</h3>
            <ul className="space-y-2" data-id="element-49">
              <li data-id="element-50">
                <Link to="/cancellation-policy" className="text-rose-100 hover:text-white" data-id="element-51">
                  Cancellation Policy
                </Link>
              </li>
              <li data-id="element-52">
                <Link to="/refund-policy" className="text-rose-100 hover:text-white" data-id="element-53">
                  Refund Policy
                </Link>
              </li>
              <li data-id="element-54">
                <Link to="/privacy-policy" className="text-rose-100 hover:text-white" data-id="element-55">
                  Privacy & Cookie Policy
                </Link>
              </li>
              <li data-id="element-56">
                <Link to="/terms" className="text-rose-100 hover:text-white" data-id="element-57">
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-58">
            <h3 className="text-lg font-semibold mb-4" data-id="element-59">Contact Us</h3>
            <ul className="space-y-3" data-id="element-60">
              <li className="flex items-start" data-id="element-61">
                <MapPin className="h-5 w-5 text-rose-300 mr-2 mt-0.5" data-id="element-62" />
                <span data-id="element-63">18 Cambridge Rd, Ilford IG3 8LU</span>
              </li>
              <li className="flex items-center" data-id="element-64">
                <Phone className="h-5 w-5 text-rose-300 mr-2" data-id="element-65" />
                <a href="tel:08000554969" className="hover:text-rose-300" data-id="element-66">
                  0800 055 4969
                </a>
              </li>
              <li className="flex items-center" data-id="element-67">
                <Mail className="h-5 w-5 text-rose-300 mr-2" data-id="element-68" />
                <a href="mailto:angelene18inandan@gmail.com" className="hover:text-rose-300" data-id="element-69">
                  angelene18inandan@gmail.com
                </a>
              </li>
            </ul>
            <h3 className="text-lg font-semibold mt-6 mb-2" data-id="element-70">Opening Hours</h3>
            <ul className="space-y-1" data-id="element-71">
              <li className="flex items-center" data-id="element-72">
                <Clock className="h-4 w-4 text-rose-300 mr-2" data-id="element-73" />
                <span data-id="element-74">Monday - Friday: 9:00am - 5:00pm</span>
              </li>
              <li className="flex items-start ml-6" data-id="element-75">
                <span data-id="element-76">Saturday - Sunday: Closed</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-8 border-t border-rose-800 pt-8" data-id="element-77">
          <div className="text-center mt-4 text-rose-200 text-sm" data-id="element-78">
            <p data-id="element-79">
              &copy; {new Date().getFullYear()} Suretask. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
};